import { MARQUEE_ITEMS } from "@/data";

function Group({ hidden }) {
    return (
        <div className="marquee-group" aria-hidden={hidden || undefined}>
            {MARQUEE_ITEMS.map((item, i) => (
                <span key={i} className="flex items-center gap-[42px]">
                    <span>{item}</span>
                    <span className="text-[#b08d57] text-[0.6rem] tracking-normal">✦</span>
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <div className="marquee" data-testid="marquee">
            <div className="marquee-track">
                <Group />
                <Group hidden />
            </div>
        </div>
    );
}
